import type { ResponseWrapper } from '@/api/types'
import { GLOBAL_API_ERROR } from '@/constants/keys'
import auth from '@/lib/auth/oAuth'
import { errorBridge } from '@/lib/error-bridge-state'
import type { AxiosResponse } from 'axios'
import axios from 'axios'

const URL = process.env.PUBLIC_MERCHANT_API_URL

const client = axios.create({
  baseURL: URL,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 对请求前的拦截器
client.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = auth.getToken()
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// 对响应的拦截器
client.interceptors.response.use(
  (response: AxiosResponse<ResponseWrapper>) => {
    return response
  },
  (error: any) => {
    errorBridge.show(
      GLOBAL_API_ERROR,
      error.message + ' in ' + error.config.url,
    )
    return Promise.reject(error)
  },
)

export default client
